import React, {
  useMemo,
} from 'react';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  useLocation,
} from 'react-router-dom';
import Button from 'pages/Dashboard/components/Button';
import Dialog from 'pages/Dashboard/components/Dialog';
import PatientTrendsContent from 'pages/Dashboard/pages/Dashboard/RTM/Trends/PatientTrendsContent';
import {
  RTMPatientTrendsParams,
} from 'pages/Dashboard/services/eventChannels';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';
import PatientName from 'views/EMR/components/PatientName';

export type RTMPatientTrendsDialogParams = RTMPatientTrendsParams;

type Props = RTMPatientTrendsDialogParams & {
  onClose: () => void;
};

export default function PatientTrendsDialog({
  patient,
  onClose,
}: Props) {
  const location = useLocation();
  const pathName = useMemo(() => new RegExp(location.pathname.split('/')?.[1]), []);
  const patientId = patient.patientId ?? 0;
  const patientName = getDisplayName(patient.formattedNames);
  const title = notEmptyString(patientName)
    ? (
      <div className="flex items-center gap-1 text-xl text-gray-600 font-semibold">
        <span>RTM Check-in Reports for</span>
        <PatientName
          patient={patient}
          onNavigateAway={onClose}
          className="text-gray-900"
          currentPath={pathName}
        />
      </div>
    )
    : 'Patient trends';

  return (
    <Dialog
      open
      onClose={onClose}
      title={title}
      maxWidth={false}
      fullWidth
      classes={{
        root: '!w-full !h-full !max-h-full min-h-0 flex flex-col !p-0 !space-y-0',
        dialog: 'hidden-backdrop populate-iframe-modal !m-0 settings-form-dialog',
        bodyRoot: '!w-screen !m-0 !max-w-[calc(100%-12px)] min-w-[1150px] !h-[calc(100vh-24px)] !overflow-hidden',
        container: '!justify-start',
        title: 'border-0 p-4 shrink-0 border-b border-gray-200',
      }}
    >
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <PatientTrendsContent patientId={patientId} />
        <div className="flex shrink-0 justify-end border-t border-gray-200 bg-white px-5 py-4">
          <Button
            type="button"
            variant="outlined"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
